<template>
  <div class="loginBg">
    <div class="loginArea">
      <div class="loginTop">
        <img class="logo1" src="../../static/images/login/logo.png" alt="" />
      </div>
      <div class="loginBottom">
        <div class="loginLeft">
          <!-- <embed type="image/svg+xml" src="../../components/ClFrame/images/login/loginbg.svg" alt="" style="width:290px;"> -->
          <!-- <svg-icon iconClass="loginbg" /> -->
          <!-- <svg style="width:300px;height:400px" aria-hidden="true">
            <use xlink:href="#icon-loginbg" />
          </svg> -->
          <!-- <img src="@/assets/icons/svg/loginbg.svg"/> -->
          <div class="testbg"></div>
          <!-- <embed
            src="../../static/icons/svg/loginbg.svg"
            type="image/svg+xml"
          /> -->
        </div>
        <div class="loginRight">
          <div class="loginTitle">{{ $t("common.loginTitle") }}</div>
          <div>
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              :rules="formRule"
            >
<!--              <el-form-item prop="org">-->
<!--                <div class="inputTitle">-->
<!--                  {{ $t("login.org") }}-->
<!--                </div>-->
<!--                <el-input-->
<!--                  v-model="form.org"-->
<!--                  :placeholder="$t('common.pleaseInput')"-->
<!--                ></el-input>-->
<!--              </el-form-item>-->
              <el-form-item prop="username">
                <div class="inputTitle">{{ $t("login.userName") }}</div>
                <el-input
                  v-model="form.username"
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <div class="inputTitle">{{ $t("login.passwords") }}</div>
                <el-input
                  v-model="form.password"
                  type="password"
                  show-password
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <div class="inputTitle">{{ $t("login.phone") }}</div>
                <el-input
                  v-model="form.phone"
                  :placeholder="$t('common.pleaseInput')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <div class="inputTitle">{{ $t("login.verifyCode") }}</div>
                <el-input
                  class="verifyInput"
                  v-model="form.verifyCode"
                  :placeholder="$t('common.pleaseInput')"
                >
                  <template slot="suffix">
                    <span style="margin-right: 5px;">|</span>
                    <el-button :disabled="getVerifyCodeDisabled" type="text" @click="debouncedSendCode">{{ $t("login.getVerifyCode") }} {{ time == 0 ? '' : '(' + time + ')' }}</el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-col :span="24">
                  <el-dropdown trigger="click" @command="switchLang">
                    <span class="el-dropdown-link">
                      语言/語言/language
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="zh">中文简体</el-dropdown-item>
                      <el-dropdown-item command="tw">中文繁體</el-dropdown-item>
                      <el-dropdown-item command="en">English</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-form-item>
              <el-form-item style="margin-top: 10px">
                <el-button type="primary" :disabled="logining || lockSeconds > 0" @click="login">{{
                  lockSeconds > 0 ? $t("login.locked") + " (" + lockText + ")" : $t("login.login")
                }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="copyRight">{{ $t("login.copyRight") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getAuth, getMsgCodeForManagerUser } from "@/api/loginService";
import { createRoutes, createRoutesBySystem } from "@/utils";
export default {
  name: "Login",
  data() {
    return {
      logining: false,
      form: {
        org: "boc",
        username: "",
        password: "",
        phone: "",
        verifyCode: ""
      },
      getVerifyCodeDisabled: false,
      otpId: "",
      time: 0,
      // 登录失败锁定倒计时（秒）
      lockSeconds: 0,
      lockTimer: null,
      debouncedSendCode: this.debounce(this.getVerifyCode, 500),
      // formRule: {
      //   org: [
      //     {
      //       required: true,
      //       message: this.$t("common.pleaseInput") + this.$t("login.org"),
      //       trigger: "blur",
      //     },
      //   ],
      //   rules: {
      //     username: [{ validate: validateCode, trigger: "blur" }],
      //   },
      //   // username: [
      //   //   {
      //   //     required: true,
      //   //     message: this.$t("common.pleaseInput") + this.$t("login.userName"),
      //   //     trigger: "blur",
      //   //   },
      //   // ],
      //   // password: [
      //   //   {
      //   //     required: true,
      //   //     message: this.$t("common.pleaseInput") + this.$t("login.passwords"),
      //   //     trigger: "blur",
      //   //   },
      //   // ],
      // },
    };
  },
  computed: {
    // 锁定剩余时间（分:秒）
    lockText() {
      const minutes = Math.floor(this.lockSeconds / 60);
      const seconds = this.lockSeconds % 60;
      return minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
    },
    formRule() {
      return {
        org: [
          {
            required: true,
            message: this.$t("common.pleaseInput") + this.$t("login.org"),
          },
        ],
        username: [
          {
            required: true,
            message: this.$t("common.pleaseInput") + this.$t("login.userName"),
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("common.pleaseInput") + this.$t("login.passwords"),
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("common.pleaseInput") + this.$t("login.phone"),
          },
          { 
            pattern: /^[1][3-9][0-9]{9}$/,
            message: this.$t("common.invalidPhone"),
            trigger: "blur"
          },
        ],
        verifyCode: [
          {
            required: true,
            message: this.$t("common.pleaseInput") + this.$t("login.verifyCode"),
          },
          { 
            pattern: /^[0-9]*$/,
            message: this.$t("common.invalidVerifyCode"),
            trigger: "blur"
          },
        ]
      };
    },
  },
  mounted() {
    setTimeout(this.switchLang("zh"), 1000);
  },
  beforeDestroy() {
    if (this.lockTimer) {
      clearInterval(this.lockTimer);
      this.lockTimer = null;
    }
  },
  methods: {
    debounce(func, delay) {
      let timer;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    login() {
      console.log(this.$store);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit("common/RESET_LIST");
          this.logining = true;
          var loginParams = {
            org: this.form.org,
            username: this.form.username,
            password: this.form.password,
            otpId: this.otpId,
            otpCode: this.form.verifyCode,
            loginPhone: this.form.phone
          };
          login(loginParams).then((res) => {
            this.logining = false;
            if (res.code == "AUTH_200000") {
              this.$store.commit("login/SET_USER", res.data);
              //获取权限
              getAuth().then((res) => {
                // console.log("res", res);
                this.$store.commit("login/SET_AUTH", res.data);
                const routes = createRoutes(res.data.routes);
                // console.log(routes)
                // console.log(createRoutesBySystem(routes))
                sessionStorage.setItem(
                  "routes",
                  JSON.stringify(createRoutesBySystem(routes))
                );
                this.$router.push({ path: "/main" });
                //中文，繁体需要单词间隔
                if (this.$i18n.locale != "en") {
                  document
                    .getElementsByTagName("body")[0]
                    .setAttribute("style", "letter-spacing:1px;");
                }
              });
            } else {
              if (res.code == "AUTH_200004") {
                // 连续失败5次，账号锁定15分钟
                this.startLockCountdown(15 * 60);
              }
              this.$message({
                message: res.returnMsg,
                type: "error",
              });
            }
          });
        }
      });
    },
    getVerifyCode() {
      const reg = /^[1][3-9][0-9]{9}$/;
      if(this.form.phone === "") {
        this.$message({
          message: this.$t("common.pleaseInput") + this.$t("login.phone"),
          type: "error",
        });
        return;
      }
      if(!reg.test(this.form.phone)) {
        this.$message({
          message: this.$t("common.invalidPhone"),
          type: "error",
        });
        return;
      }
      getMsgCodeForManagerUser({
        org: this.form.org, 
        userName: this.form.username,
        loginPhone: this.form.phone
      }).then(res => {
        if(res.returnCode == "000000") {
          this.$message({
            message: res.returnMsg,
            type: "success",
          });
          this.time = 60
          this.getVerifyCodeDisabled = true;
          this.otpId = res.returnData.otpId;
          this.mySetTimeout = setInterval(() => {
            this.time = this.time -= 1;
            if (this.time == 0) {
              clearInterval(this.mySetTimeout);
              this.getVerifyCodeDisabled = false;
            }
          }, 1000);
        }else {
          this.$message({
            message: res.returnMsg,
            type: "error",
          });
        }
      })
    },
    // 登录失败锁定倒计时
    startLockCountdown(seconds) {
      this.lockSeconds = seconds;
      if (this.lockTimer) {
        clearInterval(this.lockTimer);
      }
      this.lockTimer = setInterval(() => {
        this.lockSeconds -= 1;
        if (this.lockSeconds <= 0) {
          clearInterval(this.lockTimer);
          this.lockTimer = null;
          this.lockSeconds = 0;
        }
      }, 1000);
    },
    switchLang(language) {
      switch (language) {
        case "zh":
          this.$i18n.locale = "zh-cn";
          break;
        case "tw":
          this.$i18n.locale = "zh-tw";
          break;
        case "en":
          this.$i18n.locale = "en";
          break;
      }
      console.log(this.$i18n.locale);
      this.$store.commit("common/SET_LOCALE", this.$i18n.locale);
    },
  },
};
</script>

<style scoped lang="less">
.testbg {
  width: 300px;
  height: 400px;
  background: url("../../assets/icons/svg/loginbg.svg");
  background-size: 300px 400px;
}
.loginBg {
  background-color: blue;
  width: 100%;
  height: 100%;
  background-image: url("../../static/images/login/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
}
.loginArea {
  // height: 600px;
  //width: 800px;
  height: 80%;
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  padding: 40px;
}
.loginBottom {
  // height: 300px;
  // width: 700px;
  // position: absolute;
  // top: 125px;
  // left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loginLeft {
  // float: left;
  // height: 300px;
  width: 380px;
}
.loginRight {
  // float: left;
  // height: 300px;
  width: 350px;
}
.logo1 {
  height: 27px;
}
::v-deep .el-form-item {
  margin-bottom: 14px !important;
}
::v-deep .el-form-item__content {
  margin-left: 0px !important;
}
::v-deep .el-button--primary {
  width: 100%;
}
.loginTitle {
  white-space: nowrap;
  overflow: hidden;
  // font-family: PingFangSC-Medium;
  font-size: 28px;
  color: #212153;
  // letter-spacing: 1px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 10px;
}
.copyRight {
  text-align: center;
  // font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #c0c3cc;
  // letter-spacing: -0.06px;
  line-height: 25px;
  font-weight: 400;
}
.inputTitle {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #202224;
  line-height: 1.5;
  // letter-spacing: -0.06px;
  font-weight: 400;
}
::v-deep .el-input__inner {
  // font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #a6a6a6;
  // letter-spacing: -0.06px;
  font-weight: 400;
  height: 36px;
  line-height: 36px;
}
::v-deep .el-input__prefix {
  // font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #a6a6a6;
}
.el-dropdown-link {
  cursor: pointer;
  color: #343c6a;
  font-size: 14px;
}
</style>
